import { Experiences } from '@/src/experiences'

export const unstable_settings = {
  initialRouteName: 'rewards',
}

export default Experiences.Rewards.Navigation.Layout
